import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetAudiofromWebService } from './services/SendImageService';
import Cookies from 'js-cookie';
import Switch from 'react-switch';

function GetAudio() {
  const [AudioSrc, setAudioSrc] = useState('');
  const [loading, setLoading] = useState(false);
  const [hover, setHover] = useState(false);
  const [voice, setVoice] = useState(false);
  const [count, setCount] = useState(0);
  // const [selectedItem, setSelectedItem] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedId, setSelectId] = useState();



  const bgMusic_data = [
    {
      id: 1,
      audioSrc: 'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3',
      voiceName: 'Epic Battle Music',
    },
    {
      id: 2,
      audioSrc: 'https://pixabay.com/music/synthwave-stranger-things-124008/',
      voiceName: 'Transquility-Anno Domini...',
    },
    {
      id: 3,
      audioSrc: 'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3',
      voiceName: 'Forever-Anno Domini Be...',
    },
    {
      id: 4,
      audioSrc: 'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3',
      voiceName: 'Heaven and Hell-Jeremy...',
    },
  ]
  // Handler for when the selection changes

  const location = useLocation();
  const navigate = useNavigate();
  console.log(location);
  const items = location.state.items || []; // Accessing data passed from Screen 1
  // console.log(items);
  /* const data = {
     key: '850Q',
     // Other data to send
   };
 */
  //GetAudiofromWebService ("You are IN");

  useEffect(() => {

    const loadData = async () => {
      const scriptout = Cookies.get('scripttxt');
      console.log('cookie in getaudio');
      console.log(scriptout);
      setLoading(true);
      try {
          const payload = { text: scriptout || "Default script text" };
          const result = await GetAudiofromWebService(payload);
          console.log('Audio service result:', result);
          
          if (result) {
            // Robust check: result could be string or object
            const cleanUrl = (typeof result === 'object' && result !== null && result.url) ? result.url : result;
            setCount(cleanUrl);
          } else {
             console.warn("Audio service returned empty. Using fallback audio.");
             // Fallback to a default/static audio if generation fails
             setCount('https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3');
          }
      } catch (e) {
          console.error("Error loading audio:", e);
          setCount('https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3');
      } finally {
          setLoading(false);
      }
    }

    loadData();

    //const goin=GetAudiofromWebService ("You are IN");
    //console.log('go inhere');
    //console.log(goin);
    // setCount(goin); // Initialize or perform a side effect once
  }, []); // Empty dependency array

  /* setLoading(true);

   useEffect(() => {
       const audiores=GetAudiofromWebService('here you got');
       if(audiores)
       {
       setAudioSrc(audiores);
       setLoading(false);
       }
     }, []); // Empty dependency array
*/
  /*  const audiores=GetAudiofromWebService('here you got');
    if(audiores)
    {
    setAudioSrc(audiores);
    setLoading(false);
    }*/


  const navigateToVideo = () => {
    console.log('items are :');
    console.log(items);

    // const newKey = Math.max(...Object.keys(items).map(Number)) + 1;
    const numericKeys = Object.keys(items).filter(key => !isNaN(Number(key)));
    const newKey = numericKeys.length > 0 ? Math.max(...numericKeys.map(Number)) + 1 : 0;
    // Construct the Audio object which contains the voiceover URL
    const Audio = { audio: count };
    
    // Fix Background Music Selection logic
    // We need to find the music object that matches selectedId (from the clicked play/check button)
    let selectedMusicUrl = '';
    if (voice && selectedId) {
        const foundMusic = bgMusic_data.find(m => m.id === selectedId);
        selectedMusicUrl = foundMusic ? foundMusic.audioSrc : '';
    }

    // Create a new merged object that contains original items, the new empty slot (if intended), the background music data, AND the voiceover Audio object.
    const finalPayload = { 
        ...items, 
        bgMusicData: { music_name: selectedMusicUrl, voice_switch: voice },
        Audio: Audio 
    };
    
    console.log('Sending final payload to GetVideo:', finalPayload);
    navigate('/GetVideo', { state: { items: finalPayload } });
  };
  
  const [isPlaying, setIsPlaying] = useState(true); // Track play/pause state
  const audioRef = useRef(null); // Reference to the audio element
  const audioRefff = useRef(null); // Reference to the audio element
  // const audioRefff = useRef(new Audio());

  const togglePlayPause = (e) => {
    e.preventDefault();
    console.log('inside view');
    const audio = audioRef.current;
    console.log('audio', audio);
    audio.play();
    /*  if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }*/
    setIsPlaying(!isPlaying); // Toggle the state
  };
  // console.log('audioref', audioRef);

  let currentAudio = null;
  let currentAudioElement = null;

  const togglePlay = (item, index) => {
    // const selectedAudioUrl = item.audioSrc;
    // // setSelectedValue(selectedAudioUrl);
    // console.log('selectedAudioUrl', selectedAudioUrl);
    // // Play the selected audio
    // if (selectedAudioUrl) {
    //   const audio = new Audio(selectedAudioUrl);
    //   audio.play().catch(error => console.error("Error playing the audio file:", error));
    // }

    // const currentAudio = audioRefff.current[index].current;
    // const currentAudio = audioRefff.current;
    // console.log('currentAudio', currentAudio);
    // currentAudio.play();

    const selectedAudioUrl = item.audioSrc;
    console.log('selectedAudioUrl', selectedAudioUrl);

    // Stop the currently playing audio
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0; // Reset audio to start
    }

    // If the selected item is the same as the currently playing, just stop and reset
    if (currentAudioElement && currentAudioElement.id === `audioPlayer-${item.id}`) {
      currentAudio = null;
      currentAudioElement = null;
      return;
    }

    // Play the selected audio
    const audioElement = document.getElementById(`audioPlayer-${item.id}`);
    if (audioElement) {
      audioElement.play().then(() => {
        console.log("Audio is playing");
        currentAudio = audioElement;
        currentAudioElement = audioElement;
      }).catch(error => {
        console.error("Error playing the audio file:", error);
        // Handle autoplay restriction or other errors
        // For example, you could show a message asking the user to click again
      });
    }

  };





  // const handleChange = (event) => {
  //   setSelectedValue(event.target.value);
  //   const selectedAudioUrl = event.target.value;
  //   setSelectedValue(selectedAudioUrl);

  //   // Play the selected audio
  //   if (selectedAudioUrl) {
  //     const audio = new Audio(selectedAudioUrl);
  //     audio.play().catch(error => console.error("Error playing the audio file:", error));
  //   }
  // };
  return (
    <>
      <div className="short-creator-block">
      <div className="creator-wrapper">
        <h3 className="mb-4">AI Voice</h3>

        <div className="progress-steps">
          <div className="step-block completed"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{ cursor: hover && 'pointer' }}
            onClick={() => hover && navigate('/GetScript')}
          >
            <span className="step-label" style={{ color: hover && '#F11D28' }}>1. Choose Script</span>
            <span className="step-indicator" style={{ transform: hover && 'scale(1.06)' }}><span className="material-icons check-icon">check</span></span>
          </div>
          <div className="step-block completed">
            <span className="step-label">2. Choose Image</span>
            <span className="step-indicator"><span className="material-icons check-icon">check</span></span>
          </div>
          <div className="step-block active">
            <span className="step-label">3. Choose Video</span>
            <span className="step-indicator"><span className="material-icons check-icon">check</span></span>
          </div>
        </div>

        <form className="creator-form" action="#">
          <div className="voices">
            <div className="voice-block selected">
              <audio ref={audioRef} id='audioPlayer' src={'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3'} />
              {loading ? '' : <a className="voice-play" onClick={togglePlayPause}><span className="material-symbols-outlined">play_circle</span></a>}
              <span className="voice-name">Male - Onyx <span className="material-icons check-icon">check</span></span>
            </div>
          </div>
          <div className='flex mb-2'>
            <label htmlFor="insert-qabout" className="caption">Background Music</label>
            <Switch
              onChange={() => setVoice(!voice)}
              checked={voice}
              onColor='#FFA12C'
              onHandleColor="#fffff"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={18}
              width={48}
              className="react-switch"
              id="material-switch"
            />
          </div>

          {
            voice &&
            <>
              <div className="voices">
                <div className={`voice-block ${selectedId === 1 ? 'selected' : ''}`}>
                  <audio ref={audioRef} id='audioPlayer' src={'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3'} />
                  <a className="voice-play" onClick={(e) => { togglePlayPause(e); setSelectId(1); }}>
                    <span className="material-symbols-outlined">play_circle</span>
                  </a>
                  <span className="voice-name">Epic Battle Music <span className="material-icons check-icon">check</span></span>
                </div>
              </div>
              <div className="voices">
                <div className={`voice-block ${selectedId === 2 ? 'selected' : ''}`}>
                  <audio ref={audioRef} id='audioPlayer' src={'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3'} />
                  <a className="voice-play" onClick={(e) => { togglePlayPause(e); setSelectId(2); }}>
                    <span className="material-symbols-outlined">play_circle</span>
                  </a>
                  <span className="voice-name">Transquility-Anno Domini... <span className="material-icons check-icon">check</span></span>
                </div>
              </div>
              <div className="voices">
                <div className={`voice-block ${selectedId === 3 ? 'selected' : ''}`}>
                  <audio ref={audioRef} id='audioPlayer' src={'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3'} />
                  <a className="voice-play" onClick={(e) => { togglePlayPause(e); setSelectId(3); }}>
                    <span className="material-symbols-outlined">play_circle</span>
                  </a>
                  <span className="voice-name">Forever-Anno Be...<span className="material-icons check-icon">check</span></span>
                </div>
              </div>
              <div className="voices">
                <div className={`voice-block ${selectedId === 4 ? 'selected' : ''}`}>
                  <audio ref={audioRef} id='audioPlayer' src={'https://generateaivideo.stellans.com/api/mp3s/staticaudio.mp3'} />
                  <a className="voice-play" onClick={(e) => { togglePlayPause(e); setSelectId(4); }}>
                    <span className="material-symbols-outlined">play_circle</span>
                  </a>
                  <span className="voice-name">Heaven and Hell-Jeremy... <span className="material-icons check-icon">check</span></span>
                </div>
              </div>
            </>
          }
          {loading ? <div className="loader"></div> : <button type="button" className="btn btn-gradient" onClick={navigateToVideo}>Generate short</button>}
        </form>

      </div>

      <div className="example-part">
        <h6 className="mb-2">AI Example</h6>
        <div className="example-media">
          <video width="320" height="240" controls autoPlay muted loop>
            <source src={`${process.env.PUBLIC_URL}/images/sdtez7hexdrmt0cvpsw940fhvr_result_.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      </div>

    </>
  );
}

export default GetAudio;
